import React from "react";
import { X } from "lucide-react";

export function Dialog({ open, onClose, title, description, children, footer, testid }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[100] flex items-start justify-center p-4 pt-24 bg-black/70 backdrop-blur-[2px]"
      onMouseDown={onClose}
    >
      <div
        data-testid={testid}
        className="w-full max-w-lg bg-surface border border-lineFocus rounded-sm shadow-2xl animate-fadeup"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between px-5 py-4 border-b border-line">
          <div>
            <h2 className="head text-base font-semibold tracking-tight text-ink">{title}</h2>
            {description && <p className="text-xs text-muted mt-1">{description}</p>}
          </div>
          <button
            onClick={onClose}
            data-testid="dialog-close"
            className="text-muted hover:text-ink transition-colors duration-150"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="px-5 py-4 space-y-4">{children}</div>
        {footer && (
          <div className="flex justify-end gap-2 px-5 py-4 border-t border-line">{footer}</div>
        )}
      </div>
    </div>
  );
}
